// Version : 1.0.0
// Author : AGALYA

import { takeLatest, put, all, call } from 'redux-saga/effects';
import HousePhotosActionType from './house-photos.types';
import {
	updateHousePhotosSuccess,
	updateHousePhotosFailure,
	updateHousePhotosResponseChanged,
} from './house-photos.action';
import { encryptData } from '../../../_common/enode-decode';
import AlertManager from '../../../../utils/alertManager';
import { housePhotosUpdate } from './house-photos.service';

/** ***************** update House Photos Start ************************/
export function* updateHousePhotosId({ payload }: any) {
	try {
		const key = 'updateHousePhotosID';
		const {
			companyID,
			databaseName,
			memberID,
			memberHouseImg1,
			memberHouseImg2,
			memberHouseImg3,
			memberHouseImg4,
			memberHouseImg5,
			userID,
		} = payload;

		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			MemberID: memberID,
			MemberHouseImg1: memberHouseImg1,
			MemberHouseImg2: memberHouseImg2,
			MemberHouseImg3: memberHouseImg3,
			MemberHouseImg4: memberHouseImg4,
			MemberHouseImg5: memberHouseImg5,
			OfficerID: userID,
			Secratekey: key,
		};

		const housePhotosData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(housePhotosUpdate, housePhotosData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(updateHousePhotosFailure(responseData.data));
		} else {
			yield put(updateHousePhotosSuccess(responseData.data));
		}
	} catch (error) {
		yield put(updateHousePhotosFailure(error));
	}
}

export function* updateHousePhotosResponseClear() {
	yield put(updateHousePhotosResponseChanged());
}

export function* onHousePhotosUpdateStart() {
	yield takeLatest(HousePhotosActionType.UPDATE_HOUSE_PHOTOS_START, updateHousePhotosId);
}

export function* onHousePhotosUpdateResponseRest() {
	yield takeLatest(
		HousePhotosActionType.UPDATE_HOUSE_PHOTOS_RESPONSE_REST_START,
		updateHousePhotosResponseClear,
	);
}
/** ***************** update House Photos End ************************/

export function* housePhotosSaga() {
	yield all([call(onHousePhotosUpdateStart), call(onHousePhotosUpdateResponseRest)]);
}
